export class LoggedInUserModel {
    id: number;
    firstName: string;
    lastName: string;
    firstNameCyr: string;
    lastNameCyr: string
    username: string;
    profileId: number;
    profileTypeId: number;
    isLoggedIn: boolean;
    isVerificationRequired: boolean;
    token: string;
    roleName: string;
    organizationId: number;
    telephoneNumber: string;
}
